import React from "react";
import axios from "axios";

function LogoutButton() {
    const handleLogout = async () => {
        try {
            await axios.post("/logout/");
        } catch (err) {
            console.error("Logout failed", err);
        } finally {
            // clear any client‑side state
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");
            // full page redirect back to the login (or home) page
            window.location.href = "/login/";
        }
    };

    return (
        <span
            onClick={handleLogout}
            className="dropdown-item"
            style={{ cursor: "pointer" }}
        >
            <i className="bi bi-power fa-fw me-2"></i> Sign Out
        </span>
    );
}

export default LogoutButton;